var render = function render(){var _vm=this,_c=_vm._self._c;return _c('task-order',{attrs:{"loaded":_vm.loaded,"loadErr":_vm.loadErr,"data":_vm.data,"reportDataId":_vm.reportDataId}})
}
var staticRenderFns = []

export { render, staticRenderFns }